import { useAuth } from '../../../contexts/AuthContext';
import { useChatbot } from '../../../contexts/ChatbotContext';

export default function CodeIntegration() {
  const { user } = useAuth();
  const { chatbotPublicId } = useChatbot();

  // Code d'intégration du widget flottant
  const widgetCode = `<!-- Widget Botmaker Agency -->
<script src="https://botmaker-agency.ai/widget.js"></script>
<script>
  initBotmaker('${chatbotPublicId}', {
    position: "bottom-right", // ou "bottom-left", "top-right", "top-left"
    offset: { x: 20, y: 20 },
    lang: "fr" // ou "en", "pt"
  });
</script>`;

  // Code d'intégration inline (iframe)
  const inlineCode = `<!-- Chat Botmaker Inline -->
<iframe 
  src="https://botmaker-agency.ai/widget?id=${chatbotPublicId}"
  style="width: 100%; height: 600px; border: none; border-radius: 12px;"
></iframe>`;

  // Code d'intégration responsive
  const responsiveCode = `<!-- Chat Botmaker Responsive -->
<div style="position: relative; padding-bottom: 56.25%; height: 0;">
  <iframe 
    src="https://botmaker-agency.ai/widget?id=${chatbotPublicId}"
    style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none; border-radius: 12px;"
  ></iframe>
</div>`;

  if (!chatbotPublicId) {
    return (
      <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
        <div className="text-center text-gray-400">
         Loading integration code...
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      {/* Widget flottant */}
      <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
        <h3 className="text-lg font-medium text-white mb-4">Floating Widget</h3>
        <p className="text-sm text-gray-400 mb-4">
          Integrate the widget at the bottom right of your site. The widget appears as a button that opens when clicked.
        </p>
        <div className="bg-black/50 rounded-lg p-4">
          <pre className="text-sm text-gray-300 overflow-x-auto">
            <code>{widgetCode}</code>
          </pre>
        </div>
      </div>

      {/* Version inline */}
      <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
        <h3 className="text-lg font-medium text-white mb-4">Inline version</h3>
        <p className="text-sm text-gray-400 mb-4">
         Integrate the chat directly into a page, already open and ready to use.
        </p>
        <div className="bg-black/50 rounded-lg p-4">
          <pre className="text-sm text-gray-300 overflow-x-auto">
            <code>{inlineCode}</code>
          </pre>
        </div>
      </div>

      {/* Version responsive */}
      <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
        <h3 className="text-lg font-medium text-white mb-4">Responsive version</h3>
        <p className="text-sm text-gray-400 mb-4">
         Integrate the chat with a 16:9 ratio that adapts to the width of its container.
        </p>
        <div className="bg-black/50 rounded-lg p-4">
          <pre className="text-sm text-gray-300 overflow-x-auto">
            <code>{responsiveCode}</code>
          </pre>
        </div>
      </div>

      {/* Instructions d'intégration */}
      <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
        <h3 className="text-lg font-medium text-white mb-4">Integration instructions</h3>
        
        <div className="space-y-6">
          {/* WordPress */}
          <div className="space-y-2">
            <h4 className="text-sm font-medium text-gray-300">WordPress</h4>
            <div className="bg-black/50 rounded-lg p-4 space-y-2">
              <p className="text-gray-300">1. Go to Appearance &gt; Theme Editor</p>
              <p className="text-gray-300">2. Open the file <code>header.php</code> or <code>footer.php</code></p>
              <p className="text-gray-300">3. Paste the code just before the tag <code>&lt;/body&gt;</code></p>
            </div>
          </div>

          {/* Wix */}
          <div className="space-y-2">
            <h4 className="text-sm font-medium text-gray-300">Wix</h4>
            <div className="bg-black/50 rounded-lg p-4 space-y-2">
              <p className="text-gray-300">1. In the Wix editor, click on + Add &gt; Custom HTML code</p>
              <p className="text-gray-300">2. Paste the widget code</p>
              <p className="text-gray-300">3. For the inline version, add an HTML/iframe element and paste the URL</p>
              <p className="text-gray-300">4. Publish your site to see the changes</p>
            </div>
          </div>

          {/* Shopify */}
          <div className="space-y-2">
            <h4 className="text-sm font-medium text-gray-300">Shopify</h4>
            <div className="bg-black/50 rounded-lg p-4 space-y-2">
              <p className="text-gray-300">1. In your Shopify dashboard, go to Online Store &gt; Themes</p>
              <p className="text-gray-300">2. Click on Actions &gt; Edit code</p>
              <p className="text-gray-300">3. Open the <code>theme.liquid</code> file</p>
              <p className="text-gray-300">4. Paste the code just before the <code>&lt;/body&gt;</code> tag</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}